module.exports = __webpack_public_path__ + "static/img/cage.48cee27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cage.png
// module id = cxgI
// module chunks = 0